import { defineCommand } from '../typed-command';

export interface SetChatSelectionContextRequest {
    text?: string;
    dataIds?: string[];
    document?: {
        id: string;
        name: string;
    };
}

/** 设置下一条聊天消息使用的编辑器选择上下文。 */
export const SET_CHAT_SELECTION_CONTEXT = defineCommand<
    [request: SetChatSelectionContextRequest],
    void
>({
    id: 'chat.setSelectionContext',
    label: '设置聊天选择上下文',
});
